.footerLinks {
    display: flex;
    justify-content: flex-end;
    gap: 1em;
    margin: 40px 0;
}

.footerLink {
    composes: button from "../../styles/buttons.module.scss";
}
